import { Injectable, Injector } from "@angular/core";
import { DataTableColumn } from "./data-table.type";

const defaultInvalidValue = "N/A";
const valuesMapping = {
  undefined: defaultInvalidValue,
  null: defaultInvalidValue,
  true: "Yes",
  false: "No",
};

@Injectable()
export class DataTableService<T = unknown> {
  constructor(private injector: Injector) {}

  /** Parse/convert the data applying render method, pipes and/or any other logic */
  parseData(row: T, column: DataTableColumn<T>, value: unknown, useValuesMapping: boolean = true): unknown {
    // Apply render method
    if (column?.render) {
      value = column.render(row, column, value);
    }
    // Apply pipes
    for (const pipe of column?.pipes || []) {
      const { clazz, args } = pipe as any;

      // Add here the pipes to ignore
      const pipesToIgnore = ["TruncateTextPipe", "MoneyPipe"];

      if (pipesToIgnore.includes(clazz.name)) {
        continue;
      }

      const injector = Injector.create({
        name: "ExportDataPipeInjector",
        parent: this.injector,
        providers: [{ provide: clazz }],
      });

      const pipeToInject = injector.get<{ transform: (value: any, ...arg: any[]) => unknown }>(clazz);

      try {
        if (args?.length) {
          value = pipeToInject.transform(value, ...args);
        } else {
          value = pipeToInject.transform(value);
        }
      } catch (err) {
        console.error(err);
      }
    }

    return (
      (useValuesMapping && valuesMapping?.[value as string]) ||
      (value === "" && useValuesMapping ? defaultInvalidValue : value)
    );
  }
}
